import React from "react";
import "./style.scss";
import { ErrorMessage } from "formik";
import { WarningOutlined } from "@ant-design/icons";

type Props = {
  name: string;
};

const InputValidationError: React.FC<Props> = ({ name }) => {
  return (
    <ErrorMessage name={name}>
      {(message) => {
        return (
          <section className="input-validation-error">
            <span className="font-bold align-middle rounded text-red-500">
              <span className="input-validation-error__warning">
                <WarningOutlined />
              </span>
              {message}
            </span>
          </section>
        );
      }}
    </ErrorMessage>
  );
};

export default InputValidationError;
